<div class="databox">{{ output() }}</div>
